import './App.css';
import Menu from './components/Menu';
import Prefooter from './components/Prefooter';
import Footer from './components/Footer';
import Header from './Home/Header';

function App() {
  return (
    <div className="App">
      <Menu />
      <Prefooter />
      <Header />
      <Footer />
    </div>
  );
}

export default App;
